import { motion } from "framer-motion";
import { T } from "@/constants/testIds";
import Reveal from "@/components/Reveal";

const RULES = [
  {
    n: "01",
    title: "The hood stays on.",
    body: "Rain. Bear market. Grandma's birthday. Court appearance. On.",
  },
  {
    n: "02",
    title: "We move in silence.",
    body: "No roadmap. No promises. A dog, a hoodie, and a chart he refuses to acknowledge.",
  },
  {
    n: "03",
    title: "Outside? In this economy?",
    body: "He has been inside since the dip. He is fine. He is not fine. He is fine.",
  },
  {
    n: "04",
    title: "Do it.",
    body: "Two dogs, one conversation. You already know how it ends. Burned supply doesn't come back.",
  },
];

export default function Lore() {
  return (
    <section id="lore" className="relative bg-ink text-paper py-20 md:py-28 border-t border-white/5" data-testid={T.lore}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-12">
          <div className="kicker text-lime mb-4">The hood doctrine</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.9] max-w-4xl">
            Four rules. <span className="text-outline-lime">Zero exceptions.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {RULES.map((r, i) => (
            <Reveal key={r.n} delay={i * 0.07} className="h-full">
              <motion.div whileHover={{ rotate: i % 2 ? 1.2 : -1.2 }} className="card p-7 h-full flex flex-col">
                <div className="font-display text-5xl text-lime/90 leading-none">{r.n}</div>
                <div className="font-display text-xl md:text-2xl uppercase mt-8 leading-tight">{r.title}</div>
                <p className="mt-3 text-base text-paper/60 leading-relaxed">{r.body}</p>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
